import { render, staticRenderFns } from "./BetaCoefficient.vue?vue&type=template&id=4aed8709&scoped=true&"
import script from "./BetaCoefficient.vue?vue&type=script&lang=js&"
export * from "./BetaCoefficient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed8709",
  null
  
)

export default component.exports